(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const post = (path, body) => fetch(root() + path, { method:'POST', headers:{ 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest' }, body:JSON.stringify(body) });
  const read = async response => {
    const data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error(data.description || window.cartStrings?.error || 'Unable to update cart.');
    return data;
  };
  window.HoodieEmbroidery = {
    buildRequest(form, formData) {
      const finish = form.querySelector('hoodie-embroidery');
      if (!finish?.embroidered) return null;
      const group = crypto.randomUUID();
      const properties = {};
      for (const [key, value] of formData) {
        const match = key.match(/^properties\[(.*)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      }
      properties.Finish = 'Embroidered';
      properties._embroidery_group = group;
      properties._embroidery_role = 'hoodie';
      const id = Number(formData.get('id'));
      const quantity = Number(formData.get('quantity')) || 1;
      const names = Object.entries(properties).filter(([key]) => /^Cat \d name$/.test(key)).map(([,value]) => value).join(', ');
      return {
        items:[
          { id, quantity, properties },
          { id:Number(finish.dataset.variantId), quantity, parent_id:id, properties:{ 'For hoodie':names, 'Finish':'Embroidered', '_embroidery_group':group, '_embroidery_role':'upgrade' } }
        ],
        sections:formData.get('sections'),
        sections_url:formData.get('sections_url')
      };
    },
    async changeQuantity(line, quantity, sections, sectionsUrl) {
      const cart = await read(await fetch(root() + 'cart.js', { cache:'no-store' }));
      const selected = cart.items[Number(line) - 1];
      const group = selected?.properties?._embroidery_group;
      const requestSections = { sections, sections_url:sectionsUrl };
      if (!group) return post('cart/change.js', { line:Number(line), quantity:Number(quantity), ...requestSections });
      const related = cart.items.filter(item => item.properties?._embroidery_group === group);
      const parent = related.find(item => item.properties._embroidery_role === 'hoodie');
      const upgrade = related.find(item => item.properties._embroidery_role === 'upgrade');
      if (selected === upgrade && Number(quantity) === 0 && parent) {
        const current = await read(await post('cart/change.js', { id:upgrade.key, quantity:0 }));
        const hoodie = current.items.find(item => item.properties?._embroidery_group === group && item.properties._embroidery_role === 'hoodie');
        if (hoodie) return post('cart/change.js', { id:hoodie.key, quantity:hoodie.quantity, properties:{ ...hoodie.properties, Finish:'Printed' }, ...requestSections });
        return post('cart/update.js', { updates:{}, ...requestSections });
      }
      const updates = Object.fromEntries(related.map(item => [item.key, Number(quantity)]));
      return post('cart/update.js', { updates, ...requestSections });
    }
  };
  if (customElements.get('hoodie-embroidery')) return;
  customElements.define('hoodie-embroidery', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.variants = JSON.parse(this.dataset.variants);
      this.controller = new AbortController();
      this.addEventListener('change', () => this.update(), { signal:this.controller.signal });
      this.form.addEventListener('change', () => this.update(), { signal:this.controller.signal });
      this.form.addEventListener('vp:review', () => this.update(), { signal:this.controller.signal });
      const id = this.form.querySelector('[name="id"]');
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(id, { attributes:true });
      this.update();
    }
    get embroidered() { return this.querySelector('[value="embroidered"]').checked; }
    reset() { this.querySelector('[value="printed"]').checked = true; this.update(); }
    update() {
      this.querySelector('[data-he-finish]').value = this.embroidered ? 'Embroidered' : 'Printed';
      const variant = this.variants.find(item => String(item.id) === this.form.querySelector('[name="id"]').value);
      const quantity = Number(this.form.querySelector('[name="quantity"]')?.value || document.getElementById('hiddenQuantityInput')?.value) || 1;
      const total = ((variant?.price || 0) + (this.embroidered ? Number(this.dataset.price) : 0)) * quantity;
      const output = this.querySelector('[data-he-total]');
      if (output) output.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:this.dataset.currency }).format(total / 100);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
})();
